import { useCallback } from 'react'
import styled from 'styled-components'
import { STATICS } from '../../static'
import { XButton } from '../../components/Button'
import { useVipInfo } from '../../context/VipInfoContext'
import { formatUnits } from 'ethers/lib/utils'
import { useContract } from '../../hooks/useContract'
import { ABI_COCOS_VIP } from '../../utils/abis'
import { DialogType, useDialog } from '../../context/DialogContext'
import useEnvConfig from 'hooks/useEnvConfig'

export default function Reward() {
  const envConfig = useEnvConfig()
  const info = useVipInfo()
  const contract = useContract(envConfig.ADDRESS_COCOSVIPBOOK, ABI_COCOS_VIP)
  const { open } = useDialog()
  const handleWithdraw = useCallback(async () => {
    if (contract) {
      try {
        open(DialogType.Waiting, { title: 'Waiting for confirmation.' })
        const oper = await contract.claim()
        await oper.wait()
        open(DialogType.Success)
      } catch (e) {
        // @ts-ignore
        open(DialogType.Error, { desc: e?.data?.message || 'unknown error.' })
      }
    }
  }, [contract, open])
  return (
    <RewardWrapper>
      <VipCard>
        <Tips>My rewards:</Tips>
        <RewardToken>{formatUnits(info.referReward)} COCOS</RewardToken>
        <WithdrawButton onClick={handleWithdraw}>Withdraw</WithdrawButton>
      </VipCard>
      <MaskReact>
        <LevelItem level={1} num={info.lv1Count} />
        <LevelItem level={2} num={info.lv2Count} />
      </MaskReact>
    </RewardWrapper>
  )
}

const RewardWrapper = styled.div`
  width: 565px;
  height: 447px;
  background: linear-gradient(173deg, #11388c 0%, #11388c 100%);
  border-radius: 20px;
  position: relative;
  padding: 42px 54px;
`

const VipCard = styled.div`
  width: 456px;
  height: 278px;
  position: relative;
  border-radius: 20px;
  background-image: url(${STATICS.VipCard});
  padding-top: 74px;
  padding-left: 32px;
`
const MaskReact = styled.div`
  width: 100%;
  height: 211px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: url(${STATICS.VipReact});
  padding-top: 66px;
`
const Tips = styled.p`
  line-height: 26px;
  color: #c290ff;
  font-size: 13px;
`
const RewardToken = styled.h3`
  line-height: 28px;
  color: #fff;
  font-weight: bold;
  margin-top: 1px;
`
const WithdrawButton = styled(XButton)`
  width: 126px;
  height: 38px;
  margin-top: 15px;
`
function LevelItem(props: { level: number; num: number }) {
  return (
    <LevelItemWrapper>
      <VipIcon src={STATICS.VipIcon} />
      <Text>Number of Lv. {props.level === 1 ? 'I' : 'II'} invitations </Text>
      <Nums>{props.num}</Nums>
    </LevelItemWrapper>
  )
}

const LevelItemWrapper = styled.div`
  margin: 0 auto 16px auto;
  width: 391px;
  height: 45px;
  background: #18429e;
  border-radius: 8px;
  border: 1px solid #5f8ef4;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding-left: 18px;
`

const VipIcon = styled.img`
  width: 28px;
  height: 21px;
`
const Text = styled.p`
  width: 284px;
  height: 17px;
  line-height: 17px;
  color: #6090f8;
  font-size: 14px;
  margin-left: 13px;
`
const Nums = styled.span`
  line-height: 17px;
  color: #ffffff;
  font-size: 14px;
  margin-left: 13px;
  font-weight: bold;
`
